/** @jsx jsx */
/** @jsxFrag */
import { jsx } from '@emotion/react';
import SectionIntroduction from 'components/SectionIntroduction';
import PressReleaseImage from 'icons/PressReleaseImage';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import theme from 'theme';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface PressReleaseIntroductionProps extends React.HTMLAttributes<HTMLDivElement> {}

const PressReleaseIntroduction = React.forwardRef<HTMLDivElement, PressReleaseIntroductionProps>((props, ref) => {
  return (
    <SectionIntroduction ref={ref}>
      <div
        css={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <h1
          css={{
            '@media(max-width: 600px)': { paddingLeft: 15 },
            ...theme.typography.h1,
            marginBottom: theme.spacing(3),
            textAlign: 'left',
          }}
        >
          <FormattedMessage id={'pressrelease.text2'} />
        </h1>
      </div>
      <PressReleaseImage
        css={{
          '@media(min-width: 600px)': { display: 'block', height: 400, top: -70 },
          '@media(min-width: 960px)': {
            right: -90,
            top: -90,
          },
          '@media(min-width: 1180px)': {
            height: 400,
            width: 800,
          },
          bottom: 0,
          display: 'none',
          position: 'absolute',
          right: 0,
          width: '60%',
          zIndex: -1,
        }}
      />
    </SectionIntroduction>
  );
});

export default PressReleaseIntroduction;
